<template>
	<b-modal id="view-history-modal" hide-footer  hide-header-close no-close-on-backdrop size="xl">

		<template #modal-header> 
      
			<div>
				<v-icon name="chevron-left" @click="close()" />
			</div>
			<h5>
				{{ $t('dashboard.transactionHistory') }}
			</h5> 
			<div></div>

    </template>


		<div> 
			<div class="d-flex flex-wrap justify-content-between" v-if="showBlxDao">
				<div>
					<h5>{{ $t('dashboard.timestamp') }}</h5>
					<p>{{ formatDate(historyInfo.input.timeStamp) }}</p>

					<h5>{{ $t('dashboard.input') }}</h5>
					<p class="th-orange"> {{ historyInfo.senderWallet != null ? historyInfo.senderWallet.publicKey : "Newly generated BLX" }}  </p>

					<h5>{{ $t('dashboard.confirmations') }}</h5>
					<p> {{ historyInfo.confirmations }} </p>

					<h5>{{ $t('dashboard.hash') }}</h5>
					<p class="th-orange"><a :href="'https://explorer.blx.org/#/transaction/' + historyInfo.hash" target="_blank">{{ historyInfo.hash }}</a></p>
				</div>
				<div>
					<h5>{{ $t('history.recipient') }}</h5>
					<p class="th-orange">{{ historyInfo.recipient }}</p>

					<h5>{{ $t('dashboard.amount') }}</h5>
					<p> BLX {{ historyInfo.amount.toFixed(8) }} </p> 

					<h5>{{ $t('dashboard.status') }}</h5>
					<p v-if="historyInfo.confirmations >= 1">{{ $t('dashboard.completed') }}</p>
					<p v-else>{{ $t('dashboard.pending') }}</p>
				</div>
			</div>

			<div class="d-flex justify-content-around" v-if="showStake">
				<div>
					<h5>{{ $t('dashboard.timestamp') }}</h5>
					<p>{{ formatDate(historyInfo.createDate) }}</p>

					<h5>{{ $t('history.refId') }}</h5>
					<p class="th-orange"> {{ historyInfo.stakingId }}  </p>

					<h5>{{ $t('history.btcAmount') }}</h5>
					<p> BTC {{ historyInfo.sourceAmount.toFixed(8) }} </p> 
				</div>
				<div>
					<h5>{{ $t('history.bloxStake') }}</h5>
					<p> BLOX {{ historyInfo.targetAmount }} </p> 

					<h5>{{ $t('dashboard.status') }}</h5>
					<p>{{ historyInfo.status }}</p>

					<h5>{{ $t('history.btcAddress') }}</h5>
					<p>{{btcAddress }}</p>
				</div>
			</div>
		</div>
	</b-modal>
</template>

<script>

import qs from 'querystring' 
import numeral from 'numeral' 
export default {
  name: 'ExportImportFund',
  props: ["historyInfo", "showBlxDao", "showStake"],
  data: function() {
      return  {
      	ei: {
      		state: 'export'
      	},
		isChecked: "Mobile",
      	successExport: false,
      	showError: false,
      	exportFile: {
      		amount: "",
      		secretKey: "",
      	},
      	importFile: {
      		amount: "",
      		file: null,
      	},
      	errors: {
      		amount: "",
      		secretKey: "",
      		file: "",
      		importSecretKey: ""
      	},
		  btcAddress: ""
      }
    },
  	computed: {
    	init() {
        	return this.$store.state.init;
    	},
    	
   	},
   	methods: {
   		doneExport: function(){
   			this.successExport = false;
   			this.errors.amount = ""
   		},
   		toggleOption(selected) {
        this.ei.state = selected; 
  
      },

	  formatDate: function(time){
        return new Date(time).toLocaleString();
      },

   		close: function(){
   			this.$bvModal.hide('view-history-modal'); 
			this.errors.amount = "",
			this.errors.secretKey = "",
			this.errors.file = "",
			this.errors.importSecretKey = ""
   		},
   		
formatAmount:  function (num) {

  if(isNaN(num)) {
    num = 0;
  }
  return parseFloat(num).toFixed(8)
},

      generateDigit: function (length) {
        var text = "";
        var possible = "0123456789";

        for (var i = 0; i < length; i++){
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }

        return text;
      },
      downloadURI: function(uri, name) {
          var link = document.createElement("a");
          link.download = name;
          link.href = uri;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          //delete link;
        },

		getAddress: function(){
         const options = {
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            url: '/cx/address/BTC',
          };

          this.axios(options)
            .then((response) => {
                this.btcAddress = response.data.addressValue
              }).catch((err) => {
                  
                

                
              })
      },

        getFund: function(){
         const options = {
            method: 'GET',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            url: '/blx-api/address/' + this.assetInfo.symbol  + '/' + this.assetInfo.masterWalletAddress,
          };
          this.axios(options)
            .then((response) => {
               
               this.init.fund = response.data;

              // console.log(this.init.fund.balance);

              this.init.fund.history.sort(function(a, b) {

                return parseFloat(b.input.timeStamp) - parseFloat(a.input.timeStamp);
            });

              this.init.fund.history = this.init.fund.history.slice(0, 10);

              }).catch((err) => {
                  
                console.log(err.response.data)     

                
              })
      },


      onImport: function(){

      	let hasError = false;


      	if(this.importFile.secretKey == '' || this.importFile.secretKey == undefined || this.importFile.secretKey == null) {
					this.errors.importSecretKey = 'Secret key is required.';
					hasError = true;
				}  

				if(this.importFile.file == '' || this.importFile.file == undefined || this.importFile.file == null) {
					this.errors.file = 'File is required.';
					hasError = true;
				}  

				if(!hasError) {
					this.showError = false;

					let formData = new FormData();
      		formData.append('file', this.importFile.file);
      		formData.append('secretKey', this.importFile.secretKey);
      		formData.append('privateKey', this.init.address.issuerReference);


					 this.axios.post('/blx-api/fund/import',
									formData, {
			            headers: {
			              'Content-Type': 'multipart/form-data'
			            }
			          })
		            .then((response) => { 
		              this.showError = true;
										this.systemMsg = "Fund imported successfully";
										this.importFile.file = null;
										this.importFile.secretKey = "";
										this.getFund();
						
						
		            }).catch((err) => {
			
			
		                if(err) {
		                  this.showError = true;
		                  this.systemMsg = err.response.data.msgText;
										} 

		            }).finally ( ()=> {
										setTimeout(() => {
											this.showError = false;
											this.systemMsg = '';
											this.errors = { 
												importSecretKey: "",
												file: ""
											}
										},3000)
					
					})
				}

      },

       onExport: function(){

      	let hasError = false;

      	if(this.exportFile.amount == '' || this.exportFile.amount == undefined || this.exportFile.amount == null) {
					this.errors.amount = 'Amount is required.';
					hasError = true;
				} else {
					if(this.exportFile.amount < 0) {
						this.errors.amount = 'Amount is required.';
						hasError = true;
					}
				}

				if(!hasError) {
					this.showError = false;
					  this.exportFile.secretKey = this.generateDigit(3) + "-" + this.generateDigit(4);
					 this.axios.post('/blx-api/fund/export',
						{
							"secretKey": this.exportFile.secretKey,
						    "amount": this.exportFile.amount,
						    "privateKey": this.init.address.issuerReference
						})
		            .then((response) => { 
		             
		                console.log(response.data);

		                this.downloadURI("data:text/html," + response.data.content, response.data.hash + ".BLX");
										//this.showError = true;
										//this.systemMsg = "Fund exported successfully";
										 
										this.exportFile.amount = '';
										 //this.exportFile.secretKey = this.generateDigit(3) + "-" + this.generateDigit(4);
										 this.successExport = true;
										this.getFund();
						
						
		            }).catch((err) => {
			
			
		                if(err) {
		                  this.showError = true;
		                  this.systemMsg = err.response.data.msgText;
										} 

		            }).finally ( ()=> {
										setTimeout(() => {
											this.showError = false;
											this.systemMsg = '';
											this.errors = { 
												amount: "",
												secretKey: ""
											}
										},3000)
					
					})
				}

      }
   	},
   	mounted(){
   		this.getAddress();
   		
 		},
}
</script>
 
<style scoped lang="scss">
	 
  button {
  	margin-top:1em;
  }

   .error {
  	color: red;
   }

   p {
	   margin-top:0px;
	   padding-top:0px;
   }

   h5 {
	   font-weight:bold;
	   margin-top:5px;
   }

   .form-control {
	   background-color: #ccc;
   }

  .email-or-mobile {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 1em;

      .btn {
        color: #47525b;
        border: none;
        outline: none;
        box-shadow: none;
        border-radius: 0;
        &.active {
          color: #d8962c;
          border-bottom: 1px solid #d8962c;
        }
      }
 
    }

	@media screen and (max-width:1000px) {
		div {
			font-size:0.86em;
		}

		div h5 {
			font-size:1em;
		}
	}
	
</style>
